<script setup lang="ts">
  import { useWidgetsStore } from "@src/store";
  import { Orders } from "../Orders";
  import { WriteRandomEPC } from "../WriteRandomEPC";
  import { RepairAlarm } from "../RepairAlarm";
  import { LabelPrintingUT } from "../LabelPrintingUT";
  import { CardItem } from "../CardItem";
  import { OrderCreate } from "../OrderCreate";
  import { Alarming } from "../Alarming";
  import { CheckAlarming } from "../CheckAlarming";
  import { WriteAlarm } from "../WriteAlarm";
  import { CheckPairs } from "../CheckPairs";
  import { SearchProduct } from "../SearchProduct";
  import { CheckSales } from "../CheckSales";
  import { Fitting } from "../ProductFitting";
  import { Zoning } from "../ProductZoning";
  import { OrderCard } from "../OrderCard";
  import { SearchUHF } from "../SearchUHF";
  import { Moneymap } from "../Moneymap";

  const widgets_store = useWidgetsStore();
</script>

<template>
  <Orders
    v-if="widgets_store.isOpen('orders')"
    :style="widgets_store.getWidgetStyle('orders')"
    @close="() => widgets_store.close('orders')"
  />
  <WriteRandomEPC
    v-if="widgets_store.isOpen('write_random_epc')"
    :style="widgets_store.getWidgetStyle('write_random_epc')"
    @close="() => widgets_store.close('write_random_epc')"
  />
  <RepairAlarm
    v-if="widgets_store.isOpen('repair_alarm')"
    :style="widgets_store.getWidgetStyle('repair_alarm')"
    @close="() => widgets_store.close('repair_alarm')"
  />
  <LabelPrintingUT
    v-if="widgets_store.isOpen('label_printing_ut')"
    :epc="widgets_store.label_printing_ut.epc"
    :style="widgets_store.getWidgetStyle('label_printing_ut')"
    @close="() => widgets_store.close('label_printing_ut')"
  />
  <CardItem
    v-if="widgets_store.isOpen('card_item')"
    :item_id="widgets_store.card_item.item_id"
    :style="widgets_store.getWidgetStyle('card_item')"
    @close="() => widgets_store.close('card_item')"
  />
  <OrderCreate
    v-if="widgets_store.isOpen('order_create')"
    :style="widgets_store.getWidgetStyle('order_create')"
    @close="() => widgets_store.close('order_create')"
  />
  <SearchProduct
    v-if="widgets_store.isOpen('search')"
    :style="widgets_store.getWidgetStyle('search')"
    @close="() => widgets_store.close('search')"
  />
  <Alarming
    v-if="widgets_store.isOpen('alarming')"
    :style="widgets_store.getWidgetStyle('alarming')"
    @close="() => widgets_store.close('alarming')"
  />
  <CheckAlarming
    v-if="widgets_store.isOpen('check_alarming')"
    :style="widgets_store.getWidgetStyle('check_alarming')"
    @close="() => widgets_store.close('check_alarming')"
  />
  <WriteAlarm
    v-if="widgets_store.isOpen('write_alarm')"
    :style="widgets_store.getWidgetStyle('write_alarm')"
    @close="() => widgets_store.close('write_alarm')"
  />
  <CheckPairs
    v-if="widgets_store.isOpen('check_pairs')"
    :style="widgets_store.getWidgetStyle('check_pairs')"
    @close="() => widgets_store.close('check_pairs')"
  />
  <CheckSales
    v-if="widgets_store.isOpen('check_sales')"
    :style="widgets_store.getWidgetStyle('check_sales')"
    @close="() => widgets_store.close('check_sales')"
  />
  <Fitting
    v-if="widgets_store.isOpen('fitting')"
    :style="widgets_store.getWidgetStyle('fitting')"
    @close="() => widgets_store.close('fitting')"
  />
  <Zoning
    v-if="widgets_store.isOpen('zoning')"
    :style="widgets_store.getWidgetStyle('zoning')"
    @close="() => widgets_store.close('zoning')"
  />
  <OrderCard
    v-if="widgets_store.isOpen('order_card')"
    :style="widgets_store.getWidgetStyle('order_card')"
    @close="() => widgets_store.close('order_card')"
  />
  <SearchUHF
    v-if="widgets_store.isOpen('search_uhf')"
    :style="widgets_store.getWidgetStyle('search_uhf')"
    @close="() => widgets_store.close('search_uhf')"
  />
  <Moneymap
    v-if="widgets_store.isOpen('moneymap')"
    :style="widgets_store.getWidgetStyle('moneymap')"
    @close="() => widgets_store.close('moneymap')"
  />
</template>
